  (function() {
    var sticky = document.getElementById('stickyCta');
    var hero = document.querySelector('.hero');
    if (!sticky || !hero) return;

    function checkScroll() {
      var heroBottom = hero.getBoundingClientRect().bottom;
      if (heroBottom < 0) {
        sticky.classList.add('visible');
      } else {
        sticky.classList.remove('visible');
      }
    }

    window.addEventListener('scroll', checkScroll, { passive: true });
    checkScroll();
  })();
